import classNames from 'classnames'

export type GroupBy = `days` | `weeks` | `months`

type DateGroupProps = {
  defaultGroup?: GroupBy
  onGroupChange: (group: GroupBy) => void
  disableDays?: boolean
  disableWeeks?: boolean
  disableMonths?: boolean
  /** Leaves out the "Aggregated by:" label where the segments read clearly on their own. */
  hideLabel?: boolean
}

/**
 * Uncontrolled component that returns group selection
 * @param DateGroupProps
 * @returns React node element
 */
export default function DateGroupSelector({
  defaultGroup = `days`,
  onGroupChange,
  disableDays,
  disableWeeks,
  disableMonths,
  hideLabel = false,
}: DateGroupProps) {
  return (
    <div className="flex items-center">
      {/* Hidden below md — the Days/Weeks/Months segments are self-explanatory
          and the label wastes width/rows in the mobile chart header. */}
      {!hideLabel && <span className="mr-2 hidden text-ui-xs text-default md:inline">Aggregated by:</span>}
      <span className="isolate inline-flex space-x-0.5 rounded-md border border-transparent bg-surface-strong px-0.5 py-[3px]">
        <button
          onClick={() => {
            onGroupChange(`days`)
          }}
          type="button"
          disabled={disableDays ? true : undefined}
          className={classNames(
            `relative inline-flex items-center rounded-sm px-2.5 py-1 text-ui-xs text-strong focus:z-10 focus:outline-none disabled:text-subtle disabled:hover:bg-surface-strong md:px-4`,
            defaultGroup === `days` ? `bg-surface shadow-elevation-1` : `bg-surface-strong hover:bg-surface-muted`,
          )}
        >
          <span>Days</span>
        </button>
        <button
          onClick={() => {
            onGroupChange(`weeks`)
          }}
          type="button"
          disabled={disableWeeks ? true : undefined}
          className={classNames(
            `relative inline-flex items-center rounded-sm px-2.5 py-1 text-ui-xs text-strong focus:z-10 focus:outline-none disabled:text-subtle disabled:hover:bg-surface-strong md:px-4`,
            defaultGroup === `weeks` ? `bg-surface shadow-elevation-1` : `bg-surface-strong hover:bg-surface-muted`,
          )}
        >
          <span>Weeks</span>
        </button>
        <button
          onClick={() => {
            onGroupChange(`months`)
          }}
          type="button"
          disabled={disableMonths ? true : undefined}
          className={classNames(
            `relative inline-flex items-center rounded-sm px-2.5 py-1 text-ui-xs text-strong focus:z-10 focus:outline-none disabled:text-subtle disabled:hover:bg-surface-strong md:px-4`,
            defaultGroup === `months` ? `bg-surface shadow-elevation-1` : `bg-surface-strong hover:bg-surface-muted`,
          )}
        >
          <span>Months</span>
        </button>
      </span>
    </div>
  )
}
